<template>
  <v-dialog v-model="dialog" max-width="1180" persistent>
    <v-card class="adres-defteri-sec-card">
      <v-toolbar dark color="info">
        <v-toolbar-title>Adres Defterinden Kişi Seç</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-text-field
          flat
          solo-inverted
          hide-details
          v-model="searchara"
          label="Ara"
          append-icon="search"
          class="adres-defteri-toolbar-search"
        />

        <v-btn icon dark @click="close">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-layout row wrap align-center>
          <v-flex xs12 sm4 md3 class="pr-sm-2">
            <v-text-field
              hide-details
              v-model="RaporAdres.Isim"
              label="Ad Soyad"
              @keyup.enter.native="getList"
            />
          </v-flex>

          <v-flex xs12 sm4 md2 class="px-sm-2">
            <v-text-field
              hide-details
              v-model="RaporAdres.Telefon"
              label="Telefon"
              @keyup.enter.native="getList"
            />
          </v-flex>

          <v-flex xs12 sm4 md2 class="px-sm-2">
            <v-text-field
              hide-details
              mask="###########"
              v-model="RaporAdres.TCKimlikNo"
              label="T.C. Kimlik No"
              @keyup.enter.native="getList"
            />
          </v-flex>

          <v-flex xs12 sm4 md2 class="px-sm-2">
            <v-text-field
              hide-details
              v-model="RaporAdres.Ulke"
              label="Ülke"
              @keyup.enter.native="getList"
            />
          </v-flex>

          <v-flex xs12 sm4 md2 class="px-sm-2">
            <v-text-field
              hide-details
              v-model="RaporAdres.Sehir"
              label="Şehir"
              @keyup.enter.native="getList"
            />
          </v-flex>

          <v-flex xs12 sm4 md1 class="pl-sm-2 text-xs-right">
            <v-btn
              color="info"
              fab
              small
              dark
              :loading="progress"
              :disabled="progress"
              @click="getList"
            >
              <v-icon>search</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>

        <v-layout row wrap class="mt-3">
          <v-flex xs12>
            <v-data-table
              :headers="headersadres"
              :items="itemsadres"
              :search="searchara"
              :rows-per-page-items="[10, 25, 50]"
              :loading="progress"
              class="adres-defteri-table"
            >
              <template slot="items" slot-scope="props">
                <tr>
                  <td class="text-xs-left">{{ props.item.Kod }}</td>
                  <td class="text-xs-left">{{ props.item.Ad }}</td>
                  <td class="text-xs-left">{{ props.item.Soyad }}</td>
                  <td class="text-xs-left">{{ props.item.Telefon1 }}</td>
                  <td class="text-xs-left">{{ props.item.GSM }}</td>
                  <td class="text-xs-left">{{ props.item.Ulke }}</td>
                  <td class="text-xs-left">{{ props.item.Sehir }}</td>
                  <td class="text-xs-right">{{ props.item.TCKimlikNo }}</td>

                  <td class="text-xs-right">
                    <v-btn
                      color="primary"
                      small
                      @click="selectAdres(props.item)"
                    >
                      <v-icon left small>person_add</v-icon>
                      Seç
                    </v-btn>
                  </td>
                </tr>
              </template>

              <template slot="no-data">
                <div class="text-xs-center pa-4 grey--text">
                  Kayıt bulunamadı.
                </div>
              </template>

              <v-alert slot="no-results" :value="true" color="error" icon="warning">
                Arama sonucunda kayıt bulunamadı: {{ searchara }}
              </v-alert>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn flat color="grey darken-1" @click="clearFilter">
          Temizle
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn flat @click="close">
          Kapat
        </v-btn>

        <v-btn color="primary" @click="emitCreateNew">
          Yeni Kişi Yaz
        </v-btn>
      </v-card-actions>

      <v-snackbar
        :timeout="timeout"
        top
        right
        v-model="snackbar"
      >
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">
          Kapat
        </v-btn>
      </v-snackbar>
    </v-card>
  </v-dialog>
</template>

<script>
import tool from "@/components/app/coper/tools";

export default {
  name: "adresdefterisec",

  data() {
    return {
      dialog: false,
      progress: false,
      searchara: null,

      snackbar: false,
      timeout: 5000,
      text1: "",

      itemsadres: [],

      headersadres: [
        {
          text: "Kod",
          value: "Kod",
          width: "7%",
          align: "left"
        },
        {
          text: "Ad",
          value: "Ad",
          width: "15%",
          align: "left"
        },
        {
          text: "Soyad",
          value: "Soyad",
          width: "15%",
          align: "left"
        },
        {
          text: "Telefon",
          value: "Telefon1",
          width: "12%",
          align: "left"
        },
        {
          text: "GSM",
          value: "GSM",
          width: "12%",
          align: "left"
        },
        {
          text: "Ülke",
          value: "Ulke",
          width: "10%",
          align: "left"
        },
        {
          text: "Şehir",
          value: "Sehir",
          width: "10%",
          align: "left"
        },
        {
          text: "TC.",
          value: "TCKimlikNo",
          width: "12%",
          align: "right"
        },
        {
          text: "",
          value: "",
          width: "7%",
          sortable: false,
          align: "right"
        }
      ],

      RaporAdres: {
        Isim: null,
        Kategori: null,
        Telefon: null,
        Ulke: null,
        Sehir: null,
        OnlineCIn: null,
        DogumGunu_Gun: null,
        DogumGunu_Ay: null,
        TCKimlikNo: null
      }
    };
  },

  methods: {
    open(defaultSearch) {
      this.dialog = true;

      if (defaultSearch) {
        this.RaporAdres.Isim = defaultSearch;
      }

      this.$nextTick(function() {
        this.getList();
      });
    },

    close() {
      this.dialog = false;
    },

    emitCreateNew() {
      this.close();
      this.$emit("create-new");
    },

    clearFilter() {
      this.searchara = null;

      this.RaporAdres = {
        Isim: null,
        Kategori: null,
        Telefon: null,
        Ulke: null,
        Sehir: null,
        OnlineCIn: null,
        DogumGunu_Gun: null,
        DogumGunu_Ay: null,
        TCKimlikNo: null
      };

      this.getList();
    },

    getList() {
      this.progress = true;

      var params = Object.assign({}, this.RaporAdres);

      tool.http_post(this, "AdresList", params).then(
        response => {
          this.progress = false;

          if (response.body && response.body.Status === true) {
            this.itemsadres = response.body.data || [];
          } else {
            this.text1 =
              response.body &&
              response.body.ErrorList &&
              response.body.ErrorList.length
                ? response.body.ErrorList[0]
                : "Adres listesi getirilemedi.";

            this.snackbar = true;
          }
        },
        () => {
          this.progress = false;
          this.text1 = "Hata oluştu, tekrar deneyiniz.";
          this.snackbar = true;
        }
      );
    },

    selectAdres(item) {
      this.$emit("selected", item);
      this.close();
    }
  }
};
</script>

<style scoped>
.adres-defteri-sec-card {
  border-radius: 8px;
}

.adres-defteri-toolbar-search {
  max-width: 360px;
}

.adres-defteri-table {
  border-top: 1px solid #eeeeee;
}
</style>